export const REDUCER_NAME = 'ANALYTICS'

